import { useEffect, useState } from 'react';

/** Matches the app mobile breakpoint (`$bp-md` / 768px). */
const MOBILE_WEB_MEDIA_QUERY = '(max-width: 767px)';

export function useIsMobileWeb() {
  const [isMobileWeb, setIsMobileWeb] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_WEB_MEDIA_QUERY);
    const update = () => setIsMobileWeb(mediaQuery.matches);

    update();
    mediaQuery.addEventListener('change', update);
    return () => mediaQuery.removeEventListener('change', update);
  }, []);

  return isMobileWeb;
}
